import React from "react";
import { Form, InputGroup } from "react-bootstrap";

const InputWithIcon = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  required = false,
  icon,
  disabled = false,
  min,
  error,
  onBlur,
  message,
  className, // Accept error prop
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label className="cmn_label">
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>
      <InputGroup>
        <Form.Control
          key={name}
          disabled={disabled}
          className={`${disabled && "disabled_input"} ${
            error ? "is-invalid" : ""
          } ${className}`} // Add error styling
          type={type == "number" ? "text" : type}
          onKeyDown={(e) => {
            if (type == "number") {
              const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                ".",
              ];
              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                e.preventDefault();
              }
              // Prevent multiple decimals
              if (e.key === "." && e.currentTarget.value.includes(".")) {
                e.preventDefault();
              }
            } else {
              return true;
            }
          }}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          min={min}
          onBlur={onBlur}
        />
        {icon && <InputGroup.Text>{icon}</InputGroup.Text>}
      </InputGroup>
      {error && <p className="text-danger">{error}</p>}{" "}
      {message && <small className="text-success text-sm">{message}</small>}

      {/* Show error message */}
    </Form.Group>
  );
};

export default InputWithIcon;
